import React, { useEffect, useState } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { tourAssignmentService } from "../../services/tourAssignmentService";
import { toast } from "react-toastify";
import moment from "moment";
import Layout from "../layout/layout";
import "./assign-tourGuide.css";

const AssignTourGuide = () => {
  const { tourAssignmentId } = useParams(); // Lấy tourAssignmentId từ URL
  const navigate = useNavigate();
  const [tourDetails, setTourDetails] = useState(null);
  const [recommendedGuides, setRecommendedGuides] = useState([]);
  const [mainGuideId, setMainGuideId] = useState(null);
  const [backupGuideId, setBackupGuideId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Lấy thông tin tour và danh sách gợi ý tour guide
  useEffect(() => {
    const fetchTourDetailsAndGuides = async () => {
      setLoading(true);
      try {
        // Giả định lấy chi tiết tourAssignment từ API getPendingTourAssignments
        const tour = await tourAssignmentService.getTourAssignmentById(
          parseInt(tourAssignmentId)
        );
        setTourDetails(tour.data);
        //console.log(tour);
        if (tour) {
          //console.log(tour.data.tour.tourId);
          const guides = await tourAssignmentService.getRecommendedTourGuides(
            tour.data.tour.tourId,
            tour.data.startDate,
            tour.data.endDate
          );
          console.log(guides);
          setRecommendedGuides(guides.data);
        }
      } catch (error) {
        console.error("Error fetching tour or guides:", error);
        toast.error("Không thể tải danh sách hướng dẫn viên.");
      } finally {
        setLoading(false);
      }
    };

    fetchTourDetailsAndGuides();
  }, [tourAssignmentId]);

  // Chọn Main Tour Guide
  const handleSelectMainGuide = (guideId) => {
    setMainGuideId(guideId);
    setBackupGuideId(null); // Reset Backup khi chọn lại Main
  };

  // Chọn Backup Tour Guide
  const handleSelectBackupGuide = (guideId) => {
    setBackupGuideId(guideId);
  };

  // Quay lại chọn Main Guide
  const handleBack = () => {
    setMainGuideId(null);
    setBackupGuideId(null);
  };

  // Xác nhận phân công
  const handleConfirm = async () => {
    if (!mainGuideId || !backupGuideId) {
      toast.error("Vui lòng chọn cả Main Guide và Backup Guide.");
      return;
    }

    setLoading(true);
    try {
      const response = await tourAssignmentService.assignTourGuides(
        parseInt(tourAssignmentId),
        mainGuideId,
        backupGuideId
      );
      toast.success(response.data.message);
      navigate("/tour-assign"); // Quay lại danh sách sau khi thành công
    } catch (error) {
      console.error("Error assigning tour guides:", error);
      toast.error(
        error.response?.data?.message || "Lỗi phân công hướng dẫn viên."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Layout>
      <div>
        {/* <!-- Page Wrapper --> */}
        <div className="content">
          <div className="container">
            <div className="row">
              {/* <!-- Sidebar --> */}
              <Sidebar page="tour-assign" />
              {/* <!-- /Sidebar --> */}

              <div className="col-xl-9 col-lg-8">
                <div className="card shadow-none mb-0">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h6>
                      Phân công hướng dẫn viên cho{" "}
                      {tourDetails?.tour?.tourName || tourAssignmentId}
                    </h6>
                  </div>
                  <div className="card-body">
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      </div>
                    ) : (
                      <>
                        {!mainGuideId ? (
                          // Chọn Main Guide
                          <div>
                            <h6>Chọn Hướng dẫn viên chính</h6>
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th>Ảnh</th>
                                    <th>Họ tên</th>
                                    <th>Email</th>
                                    <th>Địa chỉ</th>
                                    <th>Số điện thoại</th>
                                    <th>Hành động</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {recommendedGuides &&
                                  recommendedGuides.length > 0 ? (
                                    recommendedGuides.map((guide) => (
                                      <tr key={guide.guideId}>
                                        <td>
                                          <img
                                            src={guide.user.imageUrl || ""}
                                            alt={guide.user.fullName}
                                            style={{
                                              width: "40px",
                                              height: "40px",
                                              borderRadius: "50%",
                                            }}
                                          />
                                        </td>
                                        <td>{guide.user.fullName}</td>
                                        <td>{guide.user.email}</td>
                                        <td>{guide.user.address || "N/A"}</td>
                                        <td>
                                          {guide.user.phoneNumber || "N/A"}
                                        </td>
                                        <td>
                                          <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() =>
                                              handleSelectMainGuide(
                                                guide.guideId
                                              )
                                            }
                                          >
                                            Chọn
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        Không có hướng dẫn viên phù hợp.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          // Chọn Backup Guide
                          <div>
                            <h6>
                              Chọn Hướng dẫn viên thay thế (Dẫn chính:{" "}
                              {recommendedGuides
                                ? recommendedGuides.find(
                                    (g) => g.guideId === mainGuideId
                                  )?.user.fullName
                                : ""}
                              )
                            </h6>
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th>Ảnh</th>
                                    <th>Họ tên</th>
                                    <th>Email</th>
                                    <th>Địa chỉ</th>
                                    <th>Số điện thoại</th>
                                    <th>Hành động</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {recommendedGuides
                                    ? recommendedGuides
                                        .filter(
                                          (guide) =>
                                            guide.guideId !== mainGuideId
                                        )
                                        .map((guide) => (
                                          <tr key={guide.guideId}>
                                            <td>
                                              <img
                                                src={guide.user.imageUrl || ""}
                                                alt={guide.user.fullName}
                                                style={{
                                                  width: "40px",
                                                  height: "40px",
                                                  borderRadius: "50%",
                                                }}
                                              />
                                            </td>
                                            <td>{guide.user.fullName}</td>
                                            <td>{guide.user.email}</td>
                                            <td>
                                              {guide.user.address || "N/A"}
                                            </td>
                                            <td>
                                              {guide.user.phoneNumber || "N/A"}
                                            </td>
                                            <td>
                                              <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() =>
                                                  handleSelectBackupGuide(
                                                    guide.guideId
                                                  )
                                                }
                                                disabled={
                                                  backupGuideId ===
                                                  guide.guideId
                                                }
                                              >
                                                {backupGuideId === guide.guideId
                                                  ? "Đã chọn"
                                                  : "Chọn"}
                                              </button>
                                            </td>
                                          </tr>
                                        ))
                                    : ""}
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                className="btn btn-secondary me-2"
                                onClick={handleBack}
                              >
                                Back
                              </button>
                              <button
                                className="btn btn-success"
                                onClick={handleConfirm}
                                disabled={!backupGuideId || loading}
                              >
                                {loading ? "Đang xác nhận..." : "Xác nhận"}
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AssignTourGuide;
